/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { Module, Node } from "@msdyn365-commerce-modules/utilities";
import React, { useEffect } from "react";
import {
  getScanResult,
  GetScanResultInput,
} from "@msdyn365-commerce-modules/retail-actions";
//import {getAttributeValuesAsync} from "@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g";
import { ToastContainer } from "react-toastify";
import { IHeaderProps } from "../definition-extensions/header.ext.props.autogenerated";

const headerView: React.FC<any & IHeaderProps<{}>> = (
  props: any & IHeaderProps<{}>
) => {
  if (
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    typeof localStorage !== "undefined"
  ) {
    const {
      HeaderTag,
      HeaderContainer,
      MobileMenuContainer,
      MobileMenuBodyContainer,
      MobileMenuLinksContainer,
      data,
      context,
      resources,
      config,
    } = props;
    // const baseUrl = process.env.MSDyn365_HOST;

    // if (localStorage.getItem("signout") === "true") {
    //   window.location.replace(`${baseUrl}/guest-home`);
    //   localStorage.setItem("signout", "false");
    // }
    if (
      typeof window !== "undefined" &&
      typeof document !== "undefined" &&
      typeof localStorage !== "undefined"
    ) {
      const [option, setOptions] = React.useState("");
      let [barCodeStatus, setBarCodeStatus] = React.useState<boolean>(false);
      const cookieBtn: any = document.querySelector(".CookiebotWidget-logo");
      if (cookieBtn) {
        cookieBtn.textContent = config.cookieBtnLabel || "Cookie Compliance";
      }

      const [productName, setProductName] = React.useState<any>();

      const arrSticky = document?.querySelectorAll(".sticky");

      arrSticky.forEach((item: any) => {
        item?.addEventListener("click", () => {
          document.body.style.paddingTop = "0px";
          setTimeout(() => {
            document.body.style.paddingTop = "80px";
          }, 50);
        });
      });

      arrSticky.forEach((item: any) => {
        item?.addEventListener("click", () => {
          document.body.style.paddingTop = "0px";
          setTimeout(() => {
            document.body.style.paddingTop = "80px";
          }, 50);
        });
      });
      //this

      async function getProduct(Barcode: any) {
        const locale =
          props.context.request.locale != "en-GB"
            ? props.context.request.locale
            : "";
        const getProduct = await getScanResult(
          new GetScanResultInput(
            props.context.actionContext.requestContext.apiSettings,
            Barcode,
            props.context.actionContext.requestContext.apiSettings.channelId
          ),
          props.context.actionContext
        )
          .then((results) => {
            return results;
          })
          .catch((error) => {
            return error;
          });

        if (getProduct) {
          if (locale == "") {
            window.location.href =
              props.context.request.url.requestUrl.origin +
              "/" +
              getProduct?.Product.Name +
              "/" +
              getProduct?.Product.RecordId +
              ".p";
          } else {
            window.location.href =
              props.context.request.url.requestUrl.origin +
              "/" +
              locale +
              "/" +
              getProduct?.Product.Name +
              "/" +
              getProduct?.Product.RecordId +
              ".p";
          }
        } else {
          if (locale == "") {
            window.location.href =
              props.context.request.url.requestUrl.origin + "/search?q=nulll";
          } else {
            window.location.href =
              props.context.request.url.requestUrl.origin +
              "/" +
              locale +
              "/search?q=nulll";
          }
        }
      }

      useEffect(() => {
        const languages = props?.config?.localesItems;

        const url = typeof window !== "undefined" ? window.location.href : null;
        const splitAnd = url?.split("&");
        const splitSlash = url?.split("/");
        let normalUrl;
        let signInUrl;

        const langs: any = languages.map((lang: any) => {
          return lang.languageCode;
        });
        for (var i = 0; i < langs.length; i++) {
          normalUrl = splitSlash?.includes(langs[i]);
          signInUrl = splitAnd?.includes("ui_locales=" + langs[i]);

          if (normalUrl || signInUrl) {
            setOptions(langs[i]);
            break;
          } else {
            setOptions("en-GB");
          }
        }
        // var langs = languages.map((lang: any) => {
        //   return lang.languageCode;
        // });
        // for (var i = 0; i < langs.length; i++) {
        //   if (window.location.href.includes("/" + langs[i])) {
        //     setOptions(langs[i]);
        //     break;
        //   } else {
        //     setOptions("en-GB");
        //   }
        // }

        const isAdmin = data.accountInformation.result?.IsB2bAdmin;

        if (!isAdmin) {
          const parent: any = document.querySelector(".admin-nonadmin");
          parent?.classList?.add("non-admin-user");
        }

        if (
          props.context.request.user.token == null &&
          props.context.request.user.isSignedIn
        ) {
          localStorage.setItem("sign_up_error", "true");
          /*VSI-Customization*/
          let baseUrl = "";
          if (context.request.locale === "en-GB") {
            baseUrl = `${context.request.url.requestUrl.origin}`;
          } else {
            baseUrl = `${context.request.url.requestUrl.origin}/${context.request.locale}`;
          }
          const signOutRedirectURL = `/guest-home/_msdyn365/signout?ru=${baseUrl}`;
          window.location.replace(baseUrl + signOutRedirectURL);
          /*VSI-Customization*/
        }

        //  getDimensionValuesWithEstimatedAvailabilitiesAsync({callerContext: context.actionContext},68719526994,{
        //   "RequestedDimensionTypeValue": 3,
        //   "MatchingDimensionValues": [
        //     {
        //       "DimensionTypeValue": 1,
        //       "DimensionValue": {
        //           "RecordId": 68719482055,
        //           "Value": "Space Black",
        //           "DimensionId": "117",
        //           "ColorHexCode": "",
        //           "ImageUrl": "",
        //           "RefinerGroup": "",
        //           "ExtensionProperties": []
        //       },
        //       "ExtensionProperties": []
        //   }
        //   ],
        //   "DefaultWarehouseOnly": false,
        //   "FilterByChannelFulfillmentGroup": true,
        //   "DeliveryModeTypeFilterValue": 0
        //   }).then((res:any) => {
        //
        //   }).catch((e) => {
        //
        //   })
      }, []);

      function indexOfSome(param: any): any {
        for (var i = 0; i < param.length; i++) {
          if (param[i].includes("ui_locales")) {
            return i;
          }
        }
      }

      const changeUrl = (e: any) => {
        let url: any =
          typeof window !== "undefined" ? window.location.href : null;

        url = url?.replace(/\/$/, "");
        let rest;
        var newString: string = "";

        //Category page url translation
        if (context.request.telemetryPageName == "Category") {
          //IF THE USER IS ON CATEGORY PAGE AND CHANGES LOCALE
          if (!e.includes("en-GB")) {
            //IF THE TARGET LOCALE IS NOT EN-GB
            const eLower = e.toLowerCase();
            const redirectURL: string = `${context.request.url.requestUrl.origin}/${eLower}`;
            newString = redirectURL;
          } else if (e.includes("en-GB")) {
            //IF THE TARGET LOCALE IS EN-GB
            const redirectURL: string = `${context.request.url.requestUrl.origin}`;
            newString = redirectURL;
          }
          typeof window !== "undefined"
            ? window.location.replace(newString)
            : null;
          return;
        }

        //For Sign in and sign up
        if (url.includes("ui_locales")) {
          rest = url.split("&");
          var index = indexOfSome(rest);
          newString = rest[index].split("=");
          var arr = [];
          for (var i = 0; i < rest.length; i++) {
            if (i == index) {
              arr.push(newString[0] + "=" + e);
            } else {
              arr.push(rest[i]);
            }
          }
          newString = arr.join("&");
        } else {
          //For every page other than sign in sign up and category
          if (!e.includes("en-GB")) {
            rest = url.split("/");

            if (rest[3]?.includes("activeTab")) {
              rest.splice(3, 1, e);
            } else {
              rest[3]?.length > 2 ? rest.splice(3, 0, e) : rest.splice(3, 1, e); //remove url's 3 index and replace it with user selected language code
            }
            const attach = rest.join("/");
            newString = attach;
          } else if (e.includes("en-GB")) {
            rest = url.split("/");

            if (rest[3]?.includes("activeTab")) {
              rest.splice(3, 1);
            } else {
              rest[3]?.length > 2 ? rest.splice(3, 0) : rest.splice(3, 1); //remove url's 3 index and replace it with user selected language code
            }
            const attach = rest.join("/");
            newString = attach;
          } else {
            rest = url.split("/");
            rest.splice(3, 0); //remove url's 3 index, FOR english
            const attach = rest.join("/");
            newString = attach;
          }
        }
        // if (url?.includes("/de") && e.includes("eng")) {
        //   newString = siteUrl;
        // } else if (!url?.includes("/de") && e.includes("de")) {
        //   newString = siteUrl + "/de";
        // }

        typeof window !== "undefined"
          ? window.location.replace(newString)
          : null;
      };

      const [scrollClass, setScrollClass] = React.useState<boolean>(false);
      typeof window !== "undefined"
        ? window.addEventListener("scroll", () => {
            _mainMenuScroll(scrollClass, setScrollClass);
          })
        : null;

      const languages = props?.config?.localesItems;

      return (
        <>
          <ToastContainer position="top-right" />

          <Module {...HeaderTag}>
            <Node {...HeaderContainer}>
              {props.context.request.user.isAuthenticated ? (
                <Node className={scrollClass ? "sticky-header" : "mainHead"}>
                  <Node {...MobileMenuContainer}>
                    <Node {...MobileMenuBodyContainer}>
                      {props.MobileMenuHeader}
                      {typeof window !== "undefined"
                        ? window.innerWidth < 1000
                          ? _renderDesktopAccountBlock(props)
                          : null
                        : null}
                      {_renderReactFragment(props.menuBar)}
                      <Node {...MobileMenuLinksContainer}>
                        {/* {props.accountLinks
                    ? props.accountLinks.map((link) => link)
                    : false}
                  {props.siteOptions}
                  {props.wishListIconMobile}
                  {props.signInLink}
                  {props.signOutLink} */}

                        <form action="" className="language-picker__form">
                          <select
                            name="language-picker-select"
                            id="language-picker-select"
                            onChange={(e) => changeUrl(e.target.value)}
                            value={option}
                          >
                            {languages.map((language: any) => {
                              return (
                                <option
                                  value={language?.languageCode}
                                  selected={
                                    language.languageCode == "en-GB"
                                      ? true
                                      : false
                                  }
                                >
                                  {language?.languageText}
                                </option>
                              );
                            })}
                            {/* <option value="/eng" selected>
                            English
                         </option>
                          <option value="/de">Deutsch</option> */}
                            {/* <option value="/fr">Français</option> */}
                          </select>
                        </form>
                      </Node>
                    </Node>
                  </Node>
                  <Node className="ms-header__head">
                    <div className="container ms-header__head__top-links">
                      <form action="" className="language-picker__form">
                        <select
                          name="language-picker-select"
                          id="language-picker-select"
                          onChange={(e) => changeUrl(e.target.value)}
                          value={option}
                        >
                          {languages.map((language: any) => {
                            return (
                              <option
                                value={language?.languageCode}
                                selected={
                                  language.languageCode == "en-GB"
                                    ? true
                                    : false
                                }
                              >
                                {language?.languageText}
                              </option>
                            );
                          })}
                          {/* <option value="/eng" selected>
                        English
                      </option>
                      <option value="/de">Deutsch</option> */}
                          {/* <option value="/fr">Français</option> */}
                        </select>
                      </form>
                    </div>
                  </Node>
                  <Node className="container ms-header__main-header">
                    <Node className="ms-header__main-header__logo-container">
                      {props.navIcon}
                      {props.logo}
                    </Node>
                    <Node className="ms-header__main-header__right-container">
                      {props.cartIcon}
                      {props.preferredStore}
                      {typeof window !== "undefined"
                        ? window.innerWidth > 1000
                          ? _renderDesktopAccountBlock(props)
                          : null
                        : null}
                    </Node>
                    <Node className="ms-header__main-header__search-container">
                      {barCodeStatus ? (
                        <div className="search-by-barcode">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              getProduct(productName);
                            }}
                          >
                            <input
                              value={productName}
                              type="text"
                              placeholder={resources.enterBarcode}
                              onChange={(e) => {
                                setProductName(e.target.value);
                              }}
                            />
                            {/* <input
                          type="submit"
                          className="search-btn"
                          onClick={() => getProduct(productName)}
                        /> */}
                            <button
                              type="submit"
                              className="search-btn"
                              onClick={() => getProduct(productName)}
                            >
                              Go
                            </button>
                          </form>
                        </div>
                      ) : (
                        _renderReactFragment(props.search)
                      )}
                      {barCodeStatus ? (
                        <button
                          className="close-search"
                          onClick={() => setBarCodeStatus(false)}
                        >
                          Goto Search
                        </button>
                      ) : (
                        <button
                          className="search-by-barcode-btn"
                          onClick={() => setBarCodeStatus(true)}
                        >
                          {resources.searchByBarCode}
                        </button>
                      )}
                    </Node>
                  </Node>
                  <Node className="top-navigation">
                    {props.logo}
                    {_renderReactFragment(props.menuBar)}
                  </Node>
                </Node>
              ) : (
                <div className="landing-page-header">
                  {typeof window !== "undefined" &&
                  context.request.telemetryPageName != "sign-in" &&
                  !window.location.href.includes("business-sign-up") ? (
                    <a
                      href={
                        context.request.url.requestUrl.origin +
                        "/onerf/_msdyn365/signin"
                      }
                    >
                      {resources.signInRegister}
                    </a>
                  ) : null}

                  {context.request.telemetryPageName == "sign-up" ||
                  context.request.telemetryPageName == "sign-in" ? null : (
                    <form action="" className="language-picker__form">
                      <select
                        name="language-picker-select"
                        id="language-picker-select"
                        onChange={(e) => changeUrl(e.target.value)}
                        value={option}
                      >
                        {languages.map((language: any) => {
                          return (
                            <option
                              value={language?.languageCode}
                              selected={
                                language.languageCode == "en-GB" ? true : false
                              }
                            >
                              {language?.languageText}
                            </option>
                          );
                        })}
                      </select>
                    </form>
                  )}
                </div>
              )}
            </Node>
          </Module>
        </>
      );
    } else {
      return null;
    }
  }
  return null;
};

function _renderDesktopAccountBlock(props: any): JSX.Element | null {
  const {
    AccountInfoDropdownParentContainer,
    AccountInfoDropdownPopoverConentContainer,
    accountInfoDropdownButton,
    signInLink,
    accountLinks,
    context,
    isOBORequest,
    switchCustomerLink,
  } = props;

  function onSignout(): void {
    let baseUrl = "";
    if (context.request.locale === "en-GB") {
      baseUrl = `${context.request.url.requestUrl.origin}`;
    } else {
      baseUrl = `${context.request.url.requestUrl.origin}/${context.request.locale}`;
    }
    const signOutRedirectURL = `${context.request.user.signOutUrl}?ru=${baseUrl}`;
    //window.location.replace(baseUrl);
    typeof window !== "undefined"
      ? window.location.replace(signOutRedirectURL)
      : null;
  }

  if (AccountInfoDropdownParentContainer) {
    if (AccountInfoDropdownPopoverConentContainer) {
      return (
        <Node {...AccountInfoDropdownParentContainer}>
          {accountInfoDropdownButton}
          <Node {...AccountInfoDropdownPopoverConentContainer}>
            {isOBORequest && switchCustomerLink}
            {accountLinks ? accountLinks.map((link: any) => link) : false}
            <a role="button" onClick={onSignout}>
              {props.resources.signOut}
            </a>
          </Node>
        </Node>
      );
    } else if (signInLink) {
      return <Node {...AccountInfoDropdownParentContainer}>{signInLink}</Node>;
    }
  }
  props.context.telemetry.error("Header content is empty, module wont render.");
  return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
  return (
    <React.Fragment>
      {items && items.length
        ? items.map((slot: React.ReactNode, index: number) => {
            return <React.Fragment key={index}>{slot}</React.Fragment>;
          })
        : null}
    </React.Fragment>
  );
}

function _mainMenuScroll(
  classState: boolean,
  setClassState: React.Dispatch<React.SetStateAction<boolean>>
): void {
  if ((window.scrollY.valueOf() || document.body.scrollTop) >= 1) {
    if (classState !== true) {
      setClassState(true);
    }
  } else if ((window.scrollY.valueOf() || document.body.scrollTop) < 1) {
    setClassState(false);
  }
}

export default headerView;
